// // assets
// import { IconDashboard } from '@tabler/icons-react';

// // constant
// const icons = { IconDashboard };

// // ==============================|| DASHBOARD MENU ITEMS ||============================== //

// const adminDashboard = {
//   id: 'dashboard',
//   title: 'Dashboard',
//   type: 'group',
//   children: [
//     {
//       id: 'default',
//       title: 'Dashboard',
//       type: 'item',
//       url: '/dashboard',
//       icon: icons.IconDashboard,
//       breadcrumbs: false
//     }
//   ]
// };

// // ==============================|| FUNCTION TO GET DASHBOARD BASED ON ROLE ||============================== //

//  const getDashboard = () => {
//   const userType = localStorage.getItem("userType"); // "Admin" | "GateKeeper"
//   if (userType === "Admin") return adminDashboard;
//   return { id: 'dashboard', title: 'Dashboard', type: 'group', children: [] }; // GateKeeper sees nothing
// };

// export default getDashboard

// dashboard.js
import { IconDashboard } from '@tabler/icons-react';

const icons = { IconDashboard };

const adminDashboard = (t) => ({
  id: 'dashboard',
  title: t("Dashboard"),
  type: 'group',
  children: [
    {
      id: 'default',
      title: t("Dashboard"),
      type: 'item',
      url: '/dashboard',
      icon: icons.IconDashboard,
      breadcrumbs: false
    }
  ]
});

const getDashboard = (t) => {
  const userType = localStorage.getItem("userType");
  if (userType === "Admin" || userType === "SubAdmin") return adminDashboard(t);
  return { id: 'dashboard', title: t("Dashboard"), type: 'group', children: [] };
};

export default getDashboard;
